import React from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import ErrorMessage from '../ErrorMessage';
import Input, { InputProps } from '../Input';
import TopFieldContent from '../TopFieldContent';
import useTranslation from '../../../../Hooks/useTranslation';
import CharactersCount from '../CharactersCount/CharactersCount';
import InputWrapper from '../InputWrapper/InputWrapper';

interface InputFieldProps extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
	charactersLimit?: number;
	showCharCounter?: boolean;
	isWrapped?: boolean;
}

const InputField = ({
	name,
	label,
	isRequired,
	className,
	placeholder,
	charactersLimit,
	showCharCounter = true,
	isWrapped,
	...inputProps
}: InputFieldProps) => {
	const { t } = useTranslation();
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<Input
				hasError={Boolean(error?.message)}
				{...inputProps}
				{...field}
				placeholder={t(placeholder)}
				maxLength={charactersLimit}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
			{charactersLimit && showCharCounter && (
				<CharactersCount limit={charactersLimit} value={field.value} />
			)}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default InputField;
